import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a48a8f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "file-edit__preview" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "file-edit__audio"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/audio-preview.png",
  class: "file-edit__image",
  alt: "audio preview"
}, null, -1))
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "file-edit__action" }
const _hoisted_8 = { class: "file-edit__info" }
const _hoisted_9 = ["disabled", "aria-label"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "17",
  height: "18",
  viewBox: "0 0 17 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.66992 1.91458L15.8537 16.6893",
    stroke: "#ED1B23",
    "stroke-width": "2",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15.8537 1.91458L1.66992 16.6893",
    stroke: "#ED1B23",
    "stroke-width": "2",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["name", "id", "value", "placeholder", "aria-label", "disabled"]

import { UploadedFileModel } from '@/models/AdditionalDataTypes'
import { useInterviewStore } from '@/stores/interviewStore'
import { computed, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageEdit',
  props: {
    file: { type: UploadedFileModel, required: true },
    placeholder: { type: String, default: '' },
    label: { type: String, default: '' },
    descr: { type: String, required: true },
    disabled: { type: Boolean, default: false },
    // Distinct from `disabled`, which also covers the submitted state: the card dims only
    // while the request is in flight and returns to full opacity once it completes.
    uploading: { type: Boolean, default: false },
},
  emits: ['handleFileRemove', 'update:descr'],
  setup(__props, { emit: emits }) {

const props = __props;



const descrInput = ref<HTMLTextAreaElement | null>(null)
const interviewStore = useInterviewStore()
const removeImgLabel = computed(() => interviewStore.getLocalization('InterviewQuestionary.UploadFiles.RemoveFileButton'))

function removeImage() {
    // The native disabled attribute blocks user clicks; this guards the programmatic path.
    if (props.disabled) {
        return
    }

    emits('handleFileRemove', props.file)
}
function onDescrChange() {
    emits('update:descr', descrInput.value?.value)
}

return (_ctx: any,_cache: any) => {
  return (!!__props.file)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["file-edit", { 'file-edit--uploading': __props.uploading }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          (__props.file.image.type === 'video/mp4')
            ? (_openBlock(), _createElementBlock("video", {
                key: 0,
                class: "file-edit__video",
                controls: "",
                src: _unref(interviewStore).getPreview(__props.file)
              }, null, 8, _hoisted_2))
            : (__props.file.image.type === 'audio/mpeg')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("audio", {
                    controls: "",
                    src: _unref(interviewStore).getPreview(__props.file)
                  }, null, 8, _hoisted_5)
                ]))
              : (_openBlock(), _createElementBlock("img", {
                  key: 2,
                  class: "file-edit__image",
                  src: _unref(interviewStore).getPreview(__props.file),
                  alt: __props.file.title
                }, null, 8, _hoisted_6)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(__props.file.title), 1),
            _createElementVNode("button", {
              onClick: removeImage,
              disabled: __props.disabled,
              class: "file-edit__remove-btn",
              "aria-label": _unref(removeImgLabel)
            }, _hoisted_11, 8, _hoisted_9)
          ])
        ]),
        _createElementVNode("textarea", {
          name: __props.file.title,
          id: __props.file.title,
          rows: "3",
          value: __props.descr,
          placeholder: __props.placeholder,
          "aria-label": __props.label,
          disabled: __props.disabled,
          onInput: onDescrChange,
          ref_key: "descrInput",
          ref: descrInput,
          class: "file-edit__textarea"
        }, null, 40, _hoisted_12)
      ], 2))
    : _createCommentVNode("", true)
}
}

})